import { Col, Row } from 'antd';
import { PhoneNumberDto, PhoneNumberTypeDto } from 'src/dtos';

interface PhoneNumbersFieldProps {
  value: (Omit<PhoneNumberDto, 'type'> & { type?: PhoneNumberTypeDto })[];
}

export const PhoneNumbersField = ({ value }: PhoneNumbersFieldProps) => {
  const mappedValue = value.map(item => {
    if (item.type) {
      return `${item.phoneNumber} (${item.type})`;
    }

    return item.phoneNumber;
  });

  return (
    <Row>
      {mappedValue.map(item => {
        return (
          <Col span={24} key={item}>
            {item}
          </Col>
        );
      })}
    </Row>
  );
};
